export class cambiarcontrasena{
  idUsuario: string;
  username: string;
  nueva: string;
}
